import axios from '@/axios'

export default {
  getProvinsi (options) {
    return axios.get('/provinsi', options)
  },
  getKota (options) {
    return axios.get('/kabupaten-kota', options)
  },
  getKecamatan (options) {
    return axios.get('/kecamatan', options)
  },
  search (options) {
    return axios.get('/sos', options)
  }
}